import WidgetEmail from 'components/Widgets/WidgetEmail';

const EmailTypeField = ({ selectItem, setNewSelectItem, disabled }) => {
  return (
    <WidgetEmail
      value={selectItem?.value}
      onChange={(val) =>
        setNewSelectItem({
          value: val ?? ' ',
          setting: {},
        })
      }
      disabled={disabled}
    />
  );
};

export default EmailTypeField;
